export const ratio = function (view, magnet, ref, options) {
    let ratio = options.ratio != null ? options.ratio : 0.5;
    if (ratio > 1) {
        ratio /= 100;
    }
    return view.getPointAtRatio(ratio);
};
//# sourceMappingURL=ratio.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/registry/edge-anchor/ratio.js
// module id = null
// module chunks = 